import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import i18n from '~/plugins/i18n'
import bootstrap from '~/plugins/bootstrap'
import App from '~/components/App'

import '~/plugins'
import '~/components'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  i18n,
  bootstrap,
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./resources/js/app.js